import React from 'react'

export interface BroadsheetHeadlineProps {
  children: React.ReactNode
  /** Accent spans — pass a `<span>` with colorized text for key figures. */
  className?: string
}

/**
 * BroadsheetHeadline
 *
 * Serif italic editorial headline used in the ROI Editorial Spread and other
 * narrative-first layouts. Matches the `.spread-headline` pattern from the
 * `roi-v2.html` mockup: DM Serif Display, 20–24 px, italic, graphite base
 * with value accents in gain/salmon.
 *
 * Phase 0 primitive — purely presentational.
 *
 * @example
 * <BroadsheetHeadline>
 *   AI saved you 47 hours this month — worth{' '}
 *   <span className="text-gain not-italic">$7,050</span>.
 * </BroadsheetHeadline>
 */
export function BroadsheetHeadline({
  children,
  className = '',
}: BroadsheetHeadlineProps): React.ReactElement {
  return (
    <p
      className={[
        'font-serif-display text-xl italic leading-relaxed text-graphite',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </p>
  )
}
